<scitis-app-global-page-header [pageTitle]="'Contact'">
  <ng-template #filterElement>
    <button (click)="onAddSupportContact()"
      [disabled]="(!isAdminRole && !isSuperAdminRole)"
      class="btn btn-primary pull-right">
      <span
      class="fa-solid fa-plus"></span>
      <span class="hidden-xs"
      translate>New support contact</span>
    </button>
  </ng-template>
</scitis-app-global-page-header>

<div class="card mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th scope="col" class="sortable" sortable="name" (sort)="onColumnSort($event)"><span translate>Name</span>
          </th>
          <th scope="col" class="sortable" sortable="type" (sort)="onColumnSort($event)"><span translate>Type</span>
        </th>
        <th scope="col" class="sortable" sortable="email" (sort)="onColumnSort($event)"><span translate>E-Mail</span>
      </th>
      <th scope="col" class="sortable" sortable="phone" (sort)="onColumnSort($event)"><span translate>Phone</span>
    </th>
    <th scope="col" class="text-right"><span translate>Actions</span></th>
  </tr>
</thead>
<tbody>
  @for (contact of contacts; track contact) {
    <tr>
      <td>
        <strong [innerText]="contact.name"></strong>
      </td>
      <td [innerText]=" contact.type"></td>
      <td [innerText]=" contact.email"></td>
      <td [innerText]=" contact.phone"></td>
      <td class="text-right">
        <scitis-admin-organization-support-contact-actions
          [contacts]="contacts"
          [organizationId]="organizationId===undefined?-1:organizationId"
          [isAdminRole]="isAdminRole"
          [isSuperAdminRole]="isSuperAdminRole"
          [contact]="contact">
        </scitis-admin-organization-support-contact-actions>
      </td>
    </tr>
  }
</tbody>
</table>
</div>
</div>
</div>
<scitis-page-summary [itemsCount]="contacts.length"
  [singleItemText]="translate.instant('Support contacts')"
  [multipleItemsText]="translate.instant('Support contacts')">

</scitis-page-summary>
